import {System} from './../../shared-components/System';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {YearService} from '../../shared-components/year/year.service';
import {Portfolio} from './portfolio.model';
import {StudentService} from '../../shared-components/student/student.service';

@Injectable()
export class PortfolioService {

    constructor(
        private http: HttpClient,
        private yearService: YearService,
        private studentService: StudentService
    ) {
    }

    getPortfolios(studentId): Observable<any> {
        return this.http.get(System.apiURL.Student + 'GetStudentPortfolios?studentId=' + studentId + '&yearId=' + this.yearService.student360Year.Id);
    }

    saveStudentPortfolio(document: Portfolio): Observable<any> {
        return this.studentService.saveStudentPortfolio(document);
    }

    auditStudentPortfolioDocument(id: number): Observable<any> {
        return this.http.post(System.apiURL.Student + `AuditStudentPortfolioDocument?StuPortDocs_ID=${id}`, {observe: 'response'});
    }

    getPortfolioCategories(Login_Id): Observable<any> {
        return this.http.get(System.apiURL.Student + `GetStudentPortfolioCategories?Login_ID=${Login_Id}`);
    }

    editStudentPortfolio(document: Portfolio): Observable<any> {
        return this.http.post(System.apiURL.Student + `EditStudentPortfolio`, document, {observe: 'response'});
    }

    deleteStudentPortfolio(document: Portfolio): Observable<any> {
        return this.http.post(System.apiURL.Student + `DeleteStudentPortfolio`, document, {observe: 'response'});
    }
}
